import React from "react";
import InformTable from "../Components/InformTable";
import { HistoryAction } from "../HistoryActionModel";
import { buildValuesTableData, buildDateTableData } from "../utils/historyActionHelpers";
import { getLicenseStatusName } from "./HistoryLicenseModel";

const formatLicenseValue = (property: string, value: any): string | null => {
    if (value === null || value === undefined) return null;
    if (property === "Status") return getLicenseStatusName(Number(value));
    return String(value);
};

const LicenseDeleted: React.FC<{ action: HistoryAction }> = ({ action }) => {
    const keyRow = [{ property: "Key", value: action.EntityName }];
    const details = buildValuesTableData(action.Changes, "old", formatLicenseValue);
    const dates = buildDateTableData(action.Changes, "old");

    return (
        <div className="inform_panel">
            <InformTable data={[...keyRow, ...details]} label="General" />
            {dates.length > 0 && <InformTable data={dates} label="Date" />}
        </div>
    );
};

export default LicenseDeleted;
